'use client';

import Link from 'next/link';
import { AppImage } from '@impacta/shared';
import { AppIcon } from '@impacta/shared';
import { FEATURE_STATS_ENABLED } from '@/lib/features';

export default function HeroSection() {
  return (
    <section className="relative min-h-[92vh] flex items-end pb-20 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <AppImage
          src="/assets/images/homepage/hero-workshop.png"
          alt="Personas participando en una actividad creativa en Santiago de Chile"
          fill
          priority
          className="object-cover"
          sizes="100vw"
        />

        {/* Dark overlay for text contrast */}
        <div className="absolute inset-0 bg-black/40" />

        {/* Turquoise overlay 25% */}
        <div
          className="absolute inset-0"
          style={{
            background:
              'linear-gradient(160deg, rgba(0,161,155,0.22) 0%, rgba(0,161,155,0.08) 40%, rgba(55,58,54,0.75) 100%)',
          }}
        />

        {/* Bottom gradient for legibility */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#373A36]/80 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="max-w-2xl">
          {/* Label */}
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-widest mb-8 border border-white/30 text-white/90 backdrop-blur-sm bg-white/10">
            <span className="w-2 h-2 rounded-full bg-[#E0DF00]" />
            Santiago · Chile
          </span>

          {/* Headline */}
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold leading-[1.0] text-white mb-6 tracking-tight">
            Aprende algo <span style={{ color: '#E0DF00' }}>extraordinario</span> este mes.
          </h1>

          <p className="text-lg md:text-xl text-white/85 leading-relaxed mb-10 max-w-xl font-normal">
            Actividades presenciales curadas, impartidas por expertos certificados. Desde aprender a
            bailar salsa hasta técnicas artísticas como el collage, o reconectar con tu historia y
            más.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              href="/activities"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full font-bold text-base transition-all duration-200 bg-[#E0DF00] text-[#373A36] hover:bg-[#00A19B] hover:text-white"
            >
              Explorar actividades
              <AppIcon name="ArrowRightIcon" size={18} />
            </Link>
            <Link
              href="/regalar#giftcards"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full font-semibold text-base border-2 border-white/60 text-white transition-all duration-200 hover:bg-white hover:text-[#373A36]"
            >
              <AppIcon name="GiftIcon" size={18} />
              Regalar una experiencia
            </Link>
          </div>

          {FEATURE_STATS_ENABLED && (
            <div className="flex items-center gap-6 mt-10">
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <AppIcon name="UserGroupIcon" size={16} />
                <span>+2.400 estudiantes</span>
              </div>
              <div className="w-px h-4 bg-white/20" />
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <AppIcon name="AcademicCapIcon" size={16} />
                <span>68 actividades disponibles</span>
              </div>
              <div className="w-px h-4 bg-white/20" />
              <div className="flex items-center gap-2 text-white/80 text-sm">
                <AppIcon name="StarIcon" size={16} />
                <span>4.9 promedio</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
